import Vue from 'vue'

// Instant Search for Algolia
import InstantSearch from 'vue-instantsearch';
Vue.use(InstantSearch);
import 'vue-instant/dist/vue-instant.css'
import VueInstant from 'vue-instant/dist/vue-instant.common'
Vue.use(VueInstant)